import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="tint" title="Preguntas frecuentes" data-id="element-41" data-mp="1gcpfsz39k8rr">
      <ul className="mx-auto max-w-4xl space-y-3" data-id="element-42" data-mp="1ge8u4k5d09qw">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        const panelId = `faq-panel-${index}`;
        return <li key={faq.question} className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-blue-100" data-id="element-43" data-mp="291wblqbc2k9b" data-mpi={index}>
              <h3 data-id="element-44" data-mp="240ff06zvtjyj">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-blue-200 md:px-7" data-id="element-45" data-mp="1z373uqd5ig6s">
                  <span className="text-lg font-extrabold tracking-tight text-slate-900" data-id="element-46" data-mp="fk0duyqn092c">
                    {faq.question}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-blue-600 transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-47" data-mp="kha24b2aieol" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-48" data-mp="1sd53zfid82o">
                {isOpen && <motion.div id={panelId} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-49" data-mp="1q94prgtir75">
                    <p className="px-5 pb-6 text-lg text-slate-600 md:px-7" data-id="element-50" data-mp="1pojnwwtg8vzl">{faq.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}